var _style, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTb10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000015346371002173483780000017272503675260855737_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 44,
    height: 44,
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F9F4C7;stroke:#231F20;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 42,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.1,29.6V16.3c-2.5,1.9-4.1,2.9-5,2.9c-0.4,0-0.8-0.2-1.1-0.5s-0.5-0.7-0.5-1.1c0-0.5,0.2-0.9,0.5-1.1 s0.9-0.5,1.6-0.9c1.2-0.6,2.1-1.1,2.8-1.8s1.3-1.3,1.9-2.1s0.9-1.2,1.1-1.4s0.5-0.3,0.9-0.3c0.5,0,0.9,0.2,1.2,0.6s0.5,1,0.5,1.7 v16.8c0,2-0.7,3-2,3c-0.6,0-1.1-0.2-1.4-0.6S11.1,30.4,11.1,29.6L11.1,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,21.1c0,1.6-0.1,3-0.3,4.1s-0.5,2.2-1.1,3.1c-0.7,1.2-1.5,2-2.5,2.7S26.3,32,25.1,32 c-1.5,0-2.8-0.4-4-1.3s-2-2-2.6-3.5c-0.3-0.8-0.5-1.7-0.7-2.7s-0.2-2-0.2-3.2c0-1.5,0.1-2.8,0.2-4s0.4-2.2,0.7-3.1 c0.6-1.4,1.4-2.5,2.5-3.2S23.4,10,25,10c1,0,1.9,0.2,2.7,0.5s1.5,0.8,2.1,1.4s1.1,1.4,1.6,2.3C32.1,15.9,32.5,18.2,32.5,21.1 L32.5,21.1z M28.5,20.8c0-1.8-0.1-3.3-0.3-4.4s-0.6-2-1.1-2.6S25.9,13,25,13c-1.3,0-2.2,0.6-2.7,2s-0.8,3.3-0.8,6 c0,1.8,0.1,3.4,0.3,4.5s0.6,2.1,1.1,2.7s1.2,0.9,2,0.9s1.6-0.3,2.1-0.9s0.9-1.5,1.1-2.7S28.5,22.7,28.5,20.8L28.5,20.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTb10);
export default __webpack_public_path__ + "static/media/Tb10.822c6a4db45e544f35de6d244d2812f2.svg";
export { ForwardRef as ReactComponent };